import React, { useRef } from "react";
import { useMaterialEffect } from "utils/hooks/useMaterialEffectHook";

const Ripple: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const refObj = useRef(null);
  const { svg, onMouseDown, onMouseLeave, onMouseUp } = useMaterialEffect({
    ref: refObj as any,
    isMaterial: true,
  });
  return React.cloneElement(React.Children.only(children) as any, {
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    ref: refObj,
    children: Array.isArray((children as any).props.children)
      ? [...(children as any).props.children, svg]
      : [(children as any).props.children, svg],
  });
};

export default Ripple;
